export default __webpack_public_path__ + "static/media/mission-pragati.a1a0fe6c.png";